import { durationFromTime, durationToTime } from "@/common/utils/DateUtils";

export enum PosConfigurationType {
  OLD = "old",
  TLM = "tlm",
}

export class PosConfiguration {
  type: PosConfigurationType | null;

  clickAndCollectPosId: string | null;

  company: number | null;
  store: number | null;
  userName: string | null;
  password: string | null;
  defaultWorkstationId: number | null;
  operatorId: number | null;
  orderTTL: string | null;
  suspendTTL: string | null;

  constructor(
    type: PosConfigurationType | null,
    clickAndCollectPosId: string | null,
    company: number | null,
    store: number | null,
    userName: string | null,
    password: string | null,
    defaultWorkstationId: number | null,
    operatorId: number | null,
    orderTTL: string | null,
    suspendTTL: string | null
  ) {
    this.type = type;

    this.clickAndCollectPosId = clickAndCollectPosId;

    this.company = company;
    this.store = store;
    this.userName = userName;
    this.password = password;
    this.defaultWorkstationId = defaultWorkstationId;
    this.operatorId = operatorId;
    this.orderTTL = orderTTL;
    this.suspendTTL = suspendTTL;
  }

  getOrderTTLAsTime(): string | null {
    if (!this.orderTTL) {
      return null;
    }
    return durationToTime(this.orderTTL);
  }

  setOrderTTLFromTime(time: string | null): void {
    if (!time) {
      this.orderTTL = time;
      return;
    }
    this.orderTTL = durationFromTime(time);
  }

  getSuspendTTLAsTime(): string | null {
    if (!this.suspendTTL) {
      return null;
    }

    return durationToTime(this.suspendTTL);
  }

  setSuspendTTLAsTime(time: string | null): void {
    if (!time) {
      this.suspendTTL = time;
      return;
    }
    this.suspendTTL = durationFromTime(time);
  }
}
